import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedProcessIds: [],
  transparency: 1,
  pointcloudsDict: {},
  pointcloudsVisibility: {},
  activePointclouds: [],
  pointBudget: 1_000_000,
  pointSize: 0.3,
  eyeDom: false,
  heightInterval: 2.0,
}

const potreeSlice = createSlice({
  name: "potree",
  initialState,
  reducers: {
    setPointCloudData: (state, { payload }) => {
      const { processId, newData } = payload;

      const oldPointCloudData = state.pointcloudsDict[processId] || {
        processId,
      };

      const mergedData = {
        ...oldPointCloudData,
        ...newData,
      };

      // Preserve existing elevationRange if it already exists
      if (oldPointCloudData.elevationRange && newData.elevationRange) {
        mergedData.elevationRange = oldPointCloudData.elevationRange;
      }

      state.pointcloudsDict[processId] = mergedData;
    },

    setPointCloudVisibility: (state, { payload }) => {
      const { processId, newData } = payload;
      
      if (!state.pointcloudsVisibility) {
        state.pointcloudsVisibility = {};
      }
      
      // Use 'processId' as the key, which will be 'global'
      const oldPointCloudData = state.pointcloudsVisibility[processId] || {
        processId: processId,
        classification: {
          enabled: false,
          classVisibility: {},
          className: {},
          classColor: {}
        }
      };

      // Special handling for nested classification object
      if (newData.classification) {
        // Merge new classification data with the old, preserving existing values
        oldPointCloudData.classification = {
          ...oldPointCloudData.classification, 
          ...newData.classification, 
          classVisibility: { 
            ...(oldPointCloudData.classification?.classVisibility || {}),
            ...(newData.classification.classVisibility || {})
          },
          className: { 
            ...(oldPointCloudData.classification?.className || {}),
            ...(newData.classification.className || {})
          },
          classColor: { 
            ...(oldPointCloudData.classification?.classColor || {}),
            ...(newData.classification.classColor || {})
          }
        };
      }

      const mergedData = {
        ...oldPointCloudData,
        ...newData,
      };

      state.pointcloudsVisibility[processId] = mergedData;
    },

    removeInactivePointCloudData: (state, { payload }) => {
      const oldPointClouds = { ...state.pointcloudsDict };
      const oldPointCloudIds = Object.keys(oldPointClouds);
      oldPointCloudIds.forEach((processId) => {
        if (
          payload.containerId == oldPointClouds[processId].containerId &&
          !payload.ids.includes(processId)
        ) {
          delete oldPointClouds[processId];
        }
      });

      state.pointcloudsDict = oldPointClouds;
      state.activePointclouds = Object.keys(oldPointClouds);
    },

    setTransparency: (state, { payload }) => {
      state.transparency = payload;
    },

    setPointBudget: (state, { payload }) => {
      state.pointBudget = payload;
    },
    setPointSize: (state, { payload }) => {
      state.pointSize = payload;
    },

    toogleEyeDom: (state, { payload }) => {
      state.eyeDom = payload;
    },
    setHeightInterval: (state, { payload }) => {
      state.heightInterval = payload;
    },
    loadDBState: (state, action) =>action.payload
  
  },
});

export const { setPointCloudData, setPointCloudVisibility, removeInactivePointCloudData,setTransparency,
  setPointBudget,toogleEyeDom,setPointSize,loadDBState,
setHeightInterval, } = potreeSlice.actions
export default potreeSlice.reducer